<template>
  <div>
    <!-- Afbeelding weergeven indien beschikbaar -->
    <b-img 
      class="mb-3" 
      v-if="imageUrl" 
      :src="imageUrl" 
      rounded 
      fluid 
      :alt="altText" 
    />
    
    <!-- Upload formulier alleen tonen in edit modus -->
    <div 
      :hidden="!editable" 
      class="border border-primary rounded p-0"
    >
      <b-form-file
        v-model="uploadedFile"
        :state="uploadedFile"
        placeholder="Selecteer een foto of sleep 'm erin..."
        drop-placeholder="Sleep de foto hier naartoe..."
        accept="image/*"
        @input="handleFileUpload"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecipeImageUploader',
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    },
    altText: {
      type: String,
      default: 'Recept afbeelding'
    }
  },
  data() {
    return {
      uploadedFile: null
    };
  },
  methods: {
    handleFileUpload() {
      if (this.uploadedFile) {
        this.$emit('image-uploaded', this.uploadedFile);
      }
    }
  }
};
</script>
